// @flow
export const VIEWS = {
  BOOKINGS: "bookings",
  WATCHDOGS: "watchdogs",
  TRANSACTIONS: "transactions",
}

export type ViewsTypes = $Values<typeof VIEWS>

export const FILTER_FIELDS = {
  DATE_FROM: "dateFrom",
  DATE_TO: "dateTo",
  STATUS: "status",
  TYPE: "type",
}

export type FilterFields = $Values<typeof FILTER_FIELDS>

export const TAB_TYPES = {
  ONE_BOOKING: "myBooking",
  SIGN_UP: "register",
  SIGN_IN: "signIn",
}

export type TabTypes = $Values<typeof TAB_TYPES>

export const WATCHDOG_INTERVALS = {
  DAILY: "daily",
  WEEKLY: "weekly",
}

export type WatchdogInterval = $Values<typeof WATCHDOG_INTERVALS>
